import {atom} from 'recoil';
export const filterType = atom<'shop' | 'reaction' | 'sort'>({
  key: 'filter/filter-type',
  default: 'shop',
});
export const isOpenFilterModal = atom<boolean>({
  key: 'filter/is-open-filter-modal',
  default: false,
});
